import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import './App.css';

function TermsAccept() {
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { termId } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    termId: termId,
    firstName: '',
    lastName: '',
    email: '',
    purchasePrice: '',
    houseNameNumber: '',
    street: '',
    city: '',
    county: '',
    postcode: '',
    agree0: false,
    agree1: false,
    agree2: false,
    agree3: false,
    agree4: false,
    agree5: false,
    agree6: false,
    isHomePlus: false, // Add this flag to identify HBR submissions
  });


  useEffect(() => {
    const toggleContentBox = (event) => {
      const contentBox = event.currentTarget.nextElementSibling;
      contentBox.classList.toggle('show');
      event.currentTarget.classList.toggle('active', contentBox.classList.contains('show'));
    };

    const buttons = document.querySelectorAll('.accordion');
    buttons.forEach(button => {
      button.addEventListener('click', toggleContentBox);
    });

    // Clean up event listeners
    return () => {
      buttons.forEach(button => {
        button.removeEventListener('click', toggleContentBox);
      });
    };
  }, []);


  const handleFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === 'checkbox' ? checked : value;

    setFormData({
      ...formData,
      [name]: newValue,
    });

    setSubmitAttempted(false); // Reset on any form change
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    // Immediately disable the submit button to prevent multiple submissions
    setIsSubmitting(true);

    // Check if all checkboxes are ticked
    if (!formData.agree0 || !formData.agree1 || !formData.agree2 || !formData.agree3 || !formData.agree4 || !formData.agree5 || !formData.agree6) {
      setSubmitAttempted(true);
      // Re-enable the button to allow fixing the form
      setIsSubmitting(false);
      return;
    }

    axios.post('/api/form-submit', { formData })
      .then((response) => {
        console.log('Form submission response:', response.data);
        if (response.data.success) {
          navigate('/thank-you/' + termId);
        } else {
          navigate('/error/');
        }
      })
      .catch((error) => {
        navigate('/error/')
        console.error(error);
      })
      .finally(() => {
        // Re-enable the button after the submission attempt (success or fail)
        setIsSubmitting(false);
      });
  };
  

  return (

    <main className="main-content">
      <section>
        <h4>Your reference: {termId}</h4>
        <h2>Please find below the Terms and Conditions of your survey report. Please read the terms carefully, before completing and submitting the acceptance form at the bottom of the page.</h2>
        <hr></hr>
        <div>
          <p>We have received an instruction from your mortgage provider to provide your RICS Home Survey Level 2 report (the "Report")</p>
          <p>This information, the attached Description of Service and attached Terms and Conditions set out the terms of our engagement by you and will form the contract between us.</p>
          <p className='bold-midnight-blue'>This information, the Description of Service and the Terms and Conditions are important and contain information about what we are providing together with
            details of your rights and commitments. You should read this information, the Description of Service, and the Terms and Conditions carefully and only confirm our
            instruction where you are happy with them.</p>
          <p>We have tried to set out this information, the Description of Service and the Terms and Conditions in an easy to read and understand format but if you do have any questions,
            please contact Us and we will be happy to help.</p>
          <p>Our website (www.esurv.co.uk) also has a dedicated Advice Hub, where you will find lots of useful information to help you understand your Report and the house buying process.</p>
        </div>
        <div>
          <p className='bold-midnight-blue'>About e.surv Chartered Surveyors</p>
          <p>We trade as e.surv Chartered Surveyors but our limited company name is e.surv Limited.</p>
          <p>Our registered company number is 02264161 and our address is Unit 1, Orion Park, Orion Way, Kettering, Northamptonshire, NN15 6PP</p>
          <p>In this information and in the Terms and Conditions, any reference to "Us", "We" or "Our" is a reference to e.surv limited.</p>
          <p>We are regulated by the Royal Institution of Chartered Surveyors ("RICS") and all Our surveyors are registered with RICS.</p>
          <p>In engaging Us as your surveyor we will provide to you a report on the Property. Details of the type of report that we will provide to you are set out below.</p>
        </div>
        <div>
          <p className='bold-midnight-blue'>How can you contact e.surv Chartered Surveyors?</p>
          <p>We are here to help so if you are unsure about anything whether in relation to this agreement or otherwise during the house buying process, please contact us for free on <span className='midnight-blue-text'>0800 169 9661</span> (select option 2) between <span className='midnight-blue-text'>8.30 am and 6.00 pm</span>, from <span className='midnight-blue-text'> Monday to Friday.</span></p>
          <p className='bold-midnight-blue'>What report will you receive?</p>
          <p>You have chosen to instruct us to provide a <span className='midnight-blue-text'>RICS Home Survey Level 2 report</span>.</p>
          <p>You consider that this report best meets your requirements and budget.</p>
          <p className='bold-midnight-blue'>What is covered in the Report?</p>
          <p>The detail on how We will carry out our services to prepare the Report is set out in the attached document <span className='midnight-blue-text'>"Description of Service"</span>.</p>
          <p>For more information, we recommend that you read the RICS Guide To Helping You Choose The Right Survey available at www.rics.org/globalassets/rics-website/media/upholding-professional-standards/sector-standards/home-survey--2021/helping-you-choose-the-right-survey.pdf .</p>
          <p>The Report and associated services are delivered in accordance with the current edition of the Home Survey Standard RICS professional statement and shall be equivalent to Level 2.</p>
          <p className='bold-midnight-blue'>What is not covered in the Report?</p>
          <div>
            <p>A RICS Home Survey Level 2 Report does not cover the following:</p>
            <ul>
              <li>No furniture will be moved, cupboards emptied or floorboards or fitted carpets lifted.</li>
              <li>Secured panels/hatches will not be removed and electrical fittings will not be undone.</li>
              <li>We will enter the roof void (where safe to do so) but will not move or lift insulation material, stored goods or other contents.</li>
              <li>We will not carry out specialist tests of service installations. We cannot therefore assess the efficiency or safety of these installations (or whether these meet current regulations).</li>
              <li>Where leisure facilities are present, any buildings housing these will be inspected but we will not report upon the leisure facilities themselves (e.g., tennis courts, swimming pools, etc.).</li>
              <li>When the subject property is a flat, the flat and approach common areas only will be inspected (including any roof spaces exclusively owned and occupied as part of the subject property). We will not inspect drains, lifts, fire alarms and security systems.</li>
              <li>We do not carry out an asbestos inspection (as defined within the Control of Asbestos Regulations 2012).</li>
              <li>We will not prepare an Energy Performance Certificate (EPC).</li>
              <li>We do not act as your legal adviser and will not comment upon legal matters or documents.</li>
            </ul>
            <p>The above is not an exhaustive list of matters that are not covered by our Report. The scope of our service and the contents of the Report are set out in the Description of Service. If you consider that there are matters that should be covered in our service or the Report that are not set out in the Description of Service, you should tell us as soon as possible.</p>
          </div>
          <p className='bold-midnight-blue'>What if this is not the 'right' report for You?</p>
          <p>If you think that the Report does not cover what you require, please contact Us and we can discuss your options as other types of report are available.</p>
          <p className='bold-midnight-blue'>Is a valuation included in the Report?</p>
          <p>This Report will include a market valuation.</p>
          <p>For the purpose of our Report, our market value is the estimated amount for which a property should exchange on the valuation date between a willing buyer and a willing seller in an arm's length transaction, after proper marketing and where the parties had each acted knowledgeably, prudently and without compulsion.</p>
          <p>We will also value on a "vacant possession" basis, and as though the proposed purchase is for owner occupation. If these assumptions are not correct you must inform us prior to us carrying out the inspection.</p>
          <p>This valuation does not guarantee that You would be able to purchase the Property for that price or subsequently to sell the Property for that price should you purchase the Property.</p>
          <p className='bold-midnight-blue'>What assumptions do you make about the legal interest in the Property?</p>
          <p>The terms below in relation to leasehold do not apply to properties in Scotland.</p>
          <p>We have not been provided with verified details of the legal interest in the property you are purchasing.</p>
          <p>For the purposes of the Report, we will assume that you are purchasing the freehold interest, unless you are buying a flat, in which case we will assume that you are buying the leasehold interest and that the relevant lease has a remaining term of at least 85 years, under which a reasonable ground rent and a service charge proportionate to the value of the Property are payable.</p>
          <p className='bold-midnight-blue'>Do you make any other assumptions in carrying out your services or providing the Report?</p>
          <p>Yes. The assumptions that we make are set out in the Description of Services and the Terms and Conditions.</p>
          <p>Please ensure that you review those and tell us if any of the assumptions are not correct.</p>
          <p className='bold-midnight-blue'>How much will the report cost?</p>
          <p>You have agreed the cost of the Report with your mortgage provider.</p>
          <p className='bold-midnight-blue'>When will You have to pay?</p>
          <p>You have agreed with your mortgage provider when the fees associated with the Report will be payable.</p>
          <p className='bold-midnight-blue'>When will the surveyor visit the Property?</p>
          <p>We will arrange for the surveyor to visit the Property as soon as practicable.</p>
          <p>While we will seek to inspect the property promptly our ability to do so will depend on the availability of the property owner and/or third parties (for example estate agents) to provide access.</p>
          <p className='bold-midnight-blue'>What is e.surv's maximum liability?</p>
          <p className='midnight-blue-text'>Our maximum aggregate liability to you in relation to the valuation is 50% of the lower of: (i) our valuation of the Property, or (ii) the purchase price.</p>
          <p className='midnight-blue-text'>This means that if we value the property at £200,000, but you then purchase for £190,000, the maximum payment you could recover from us would be £95,000.</p>
          <p className='midnight-blue-text'>Our maximum aggregate liability to you in relation to all other matters is £50,000.</p>
          <p className='midnight-blue-text'>More information on limitations to e.surv's liability are set out in the Terms and Conditions. You should read the Terms and Conditions carefully and ensure that you are happy with them.</p>
          <p className='bold-midnight-blue'>Do any other terms apply?</p>
          <p>This information, the attached Description of Service and the Terms and Conditions apply to our engagement and the Report.</p>
        </div>
        <div>
          <h4 className='bold-midnight-blue'>Next steps</h4>
          <p>If you are happy with the details set out in this Engagement Information, the Description of Service and the Terms and Conditions please complete the confirmation section at the bottom of this information</p>
          <p>In accordance with RICS regulations we will not be able to prepare or release a Report to you unless: (i) we have received the information required in the confirmation section below; and (ii) you have ticked all the boxes to confirm acceptance of the statements set out in that section. If you do not agree with any of the statements, please contact Us.</p>
          <p>In order to supply you with your Report as quickly as possible, please provide Us with a current email address. You can do this by providing your email address in the "contract acceptance" section below. Alternatively, you can contact reports.admin@esurv.co.uk quoting the booking reference shown above.</p>
          <p>Please take a moment to carefully read through the documents attached.</p>
          <p className='midnight-blue-text'>Before we can release your Report and in accordance with RICS regulations, we need you to accept this contract and return it to us. You will also need to tick the boxes at the bottom of the page to confirm that you understand and accept the various terms. We will not be able to send the report to you until we have received this accepted contract.</p>
          <p className='midnight-blue-text'>So that we may supply you with your Report as quickly as possible, please provide us with a current email address. You can do this by providing your email address in the "contract acceptance" section below. Alternatively, you can contact reports.admin@esurv.co.uk quoting the booking reference shown below.</p>
          <p>Our website features a dedicated Advice Hub, where you'll find lots of useful information to help you understand your Report and the house buying process.</p>
          <p className='midnight-blue-text'>The reference for your booking can be found above. Please quote this any time you need to contact us.</p>
          <p className='bold-midnight-blue'>Please read the following important Terms and Conditions before you sign up to receive our Services and for Us to provide a Report and check that they contain everything that you want and nothing that you are not willing to agree.</p>
          <p className='bold-midnight-blue'>Summary of some of your key rights:</p>
        </div>
        <div className='boundary-box'>
          <p>The Consumer Contracts (Information, Cancellation and Additional Charges) Regulations 2013 say that in most cases, you can cancel within 14 days. If you agree the services will start within this time, you may be charged for what you've used.</p>
          <p>The Consumer Rights Act 2015 Says:</p>
          <ul>
            <li>You can ask us to repeat or fix a service if it's not carried out with reasonable care and skill, or get some money back if we can't fix it.</li>
            <li>If a price hasn't been agreed upfront, what you're asked to pay must be reasonable.</li>
            <li>If a time hasn't been agreed upfront, it must be carried out within a reasonable time.</li>
          </ul>
          <p>This is a summary of some of your key rights. For detailed information from Citizens Advice please visit www.citizensadvice.org.uk or call <span className='midnight-blue-text'>03454 04 05 06</span>.</p>
        </div>
        <div>
          <button type="button" className="accordion"><h3>1 Introduction</h3></button>
          <div className="content-box">
            <p>1.1 In these Terms and Conditions, any reference to "Us", "We" or "Our" is a reference to e.surv limited. Any reference in these Terms and Conditions to "You" is to the person named in the Engagement Letter.</p>
            <p>1.2 These Terms and Conditions together with the Engagement Letter and the relevant Description of Service form the contract that we have with You under which We carry out our service and provide the Report. </p>
          </div>

          <button type="button" className="accordion"><h3>2 Information we give you</h3></button>
          <div className="content-box">
            <p>2.1 By law, the Consumer Contracts (Information, Cancellation and Additional Charges) Regulations 2013 say that we must give you certain key information before a legally binding contract between you and us is made (see the summary box below).</p>
            <ul>
              <p>Information we will give you:</p>
              <li>the main characteristics of the services you want to buy</li>
              <li>who we are, where we are based and how you can contact us</li>
              <li>the total price of the services including any taxes (or where this cannot reasonably be worked out in advance, the manner in which we will work out the price)</li>
              <li>the arrangements for payment, carrying out the services and the process we will undertake to arrange a time for carrying out the services</li>
              <li>how to exercise your right to cancel the contract and the costs of doing so</li>
              <li>our complaint handling policy.</li>
            </ul>
            <p>2.2 We will give you this information in a clear and understandable way. Typically, our representative will give you this information by email before you buy the services from us. Some of this information is also set out in this contract, such as information on our complaint handling policy (see clause 23).</p>
            <p>2.3 The key information we give you by law forms part of this contract (as though it is set out in full here).</p>
            <p>2.4 If we have to change any key information once a legally binding contract between you and us is made, we can only do this if you agree to it.</p>
          </div>

          <button type="button" className="accordion"><h3>3 The Service</h3></button>
          <div className="content-box">
            <p>3.1 We shall provide the service set out in the Engagement Letter and described in the relevant Description of Service, which shall be delivered in accordance with the current edition of the Home survey standard RICS professional statement and shall be equivalent to the level set out in the engagement letter.</p>
            <p>3.2 The service and Report have the features set out in our Engagement Letter and the relevant Description of Service.</p>
          </div>

          <button type="button" className="accordion"><h3>4 The Surveyor</h3></button>
          <div className="content-box">
            <p>4.1 The service will be provided by an AssocRICS, MRICS or FRICS member of the Royal Institution of Chartered Surveyors (RICS) who has the skills, knowledge and experience to survey and report on the property. Where the surveyor is also providing a valuation of the property, they have the skills, knowledge, and experience to provide such a valuation and are a member of the RICS Valuer Registration Scheme.</p>
            <p>4.2 Our contact information is set out in the Engagement Letter.</p>
          </div>

          <button type="button" className="accordion"><h3>5 The Inspection</h3></button>
          <div className="content-box">
            <p>5.1 Before the inspection, you should tell us if there is already an agreed or proposed price for the property, and if you have any particular concerns about the property (such as a crack noted above the bathroom window or any plans for extension).</p>
            <p>5.2 The inspection specific details set out in the Engagement Letter shall apply to the inspection.</p>
          </div>

          <button type="button" className="accordion"><h3>6 The Report</h3></button>
          <div className="content-box">
            <p>6.1 We will provide a property-specific report for the service in accordance with the current edition of the Home survey standard RICS professional statement.</p>
            <p>6.2 The nature and content of the report will vary between the different levels of service.</p>
            <p>6.3 Any report specific details set out in the Engagement Letter shall apply to the Report.</p>
            <p>6.4 Unless otherwise expressly agreed or stated our Surveyor will, in carrying out the Report, assume:</p>
            <ul>
              <li>6.4.1 that the property has/is sold with vacant possession</li>
              <li>6.4.2 that all required, valid planning permissions and statutory approvals for the buildings and for their use, including any extensions or alterations, have been obtained and complied with</li>
              <li>6.4.3 that no damaging or hazardous materials or techniques have been used, that there is no contamination in or from the ground, and it is not landfilled ground</li>
              <li>6.4.4 that the property is not subject to any unusual or especially onerous restrictions, encumbrances or outgoings and that good title can be shown</li>
              <li>6.4.5 that the property and its value are unaffected by any matters which would be revealed by a Local Search (or their equivalent in Scotland) and replies to the usual legal enquiries, or by a Statutory Notice and that neither the property, nor its condition, its use, or its intended use, is or will be unlawful</li>
              <li>6.4.6 that an inspection of those parts which have not been inspected, would not reveal material defects or cause the surveyor to alter any valuation materially</li>
              <li>6.4.7 that the property is connected to and there is the right to use the reported main services on normal terms</li>
              <li>6.4.8 that sewers, main services and the roads giving access to the property have been adopted, and that any lease provides rights of access and egress over all communal estate roadways, pathways, corridors, stairways and to use communal grounds, parking areas and other facilities; and</li>
              <li>6.4.9 that in the case of a new build property, the property has the benefit of an appropriate warranty or professional consultant certificate.</li>
            </ul>
            <p style={{ fontWeight: 'bold', fontSize: '14px' }}>If any of these assumptions is not correct, You should tell us immediately as they may impact on the services we provide and/or any valuation of the property. We will not be responsible or liable to You as a result of an assumption being incorrect, where you have not told us that the assumption is incorrect.</p>
          </div>

          <button type="button" className="accordion"><h3>7 Asbestos Exclusion</h3></button>
          <div className="content-box">
            <p>7.1 We will not carry out any asbestos inspection and the surveyor does not act as an asbestos inspector when delivering a service that may fall within the scope of The Control of Asbestos Regulations 2012.</p>
          </div>

          <button type="button" className="accordion"><h3>8 Charges and Terms of Payment</h3></button>
          <div className="content-box">
            <p>8.1 You agree to pay our fee and any other charges set out in the Engagement Letter, or as further agreed between you and us in writing.</p>
            <p>8.2 Unless otherwise set out in the Engagement Letter We will call you to arrange payment once we have received the confirmations referred to in the Engagement Letter from you. We will not be able to make arrangements to inspect the Property or issue the Report until we have received payment.</p>
            <p>8.3 If it is found on, or prior to, arrival at the Property, that it differs substantially from the description previously given, or it is outside the surveyor's experience, or we agree that it would be in your best interests to commission another level of survey (for details of our other survey products, please refer to the "Home Surveys Information Sheet" which has been provided to you). In this event, we will provide you with adjusted terms (if any) that apply to the new survey type and the inspection will not proceed until you have agreed to any such new terms and paid any additional fees that apply.</p>
            <p>8.4 If, when our surveyor arrives at the property it is not possible to carry out an inspection due to reasons outside our control (for example, where the owner does not allow access) we may charge you an aborted visit fee. Any abort visit fee will be no more than 50% of the fee set out in the Engagement Letter.</p>
            <p>8.5 Where we receive payment from You in advance of provision (or completion) of the services and/or Report such payments do not constitute client money and consequently the RICS' Client Money Protection Scheme rules do not apply to those payments</p>
          </div>

          <button type="button" className="accordion"><h3>9 Interest</h3></button>
          <div className="content-box">
            <p>9.1 Where you do not pay an amount due to us on the date that it is payable we shall be entitled to apply interest to the outstanding amount at a daily rate equal to 8% per annum and such interest shall be payable in addition on demand.</p>
          </div>

          <button type="button" className="accordion"><h3>10 Retention of Documents</h3></button>
          <div className="content-box">
            <p>10.1 We will retain all files and documents for a reasonable period, which will in any event be not less than 6 years after completion or termination of the service(s). These will be securely stored and available for future inspection, if required, for up to a maximum of 15 years.</p>
          </div>

          <button type="button" className="accordion"><h3>11 Audit of Files</h3></button>
          <div className="content-box">
            <p>11.1 As an RICS regulated firm, external organisations may conduct audit or quality assurance reviews on our practice. Your file may be subject to monitoring and review, and we will need to provide this to RICS on request in accordance with RICS Rules of Conduct for Members and/or RICS Rules of Conduct for Firms.</p>
          </div>

          <button type="button" className="accordion"><h3>12 Mortgage Provider Instruction and Referral fees</h3></button>
          <div className="content-box">
            <p>12.1 Where we receive the instruction from your Mortgage provider, we will receive payment for our services from them.</p>
            <p>12.2 We may pay or receive a referral fee either individually or as part of a third-party commercial relationship. If you have been referred to us by a third party, the relevant third party may receive a fee from us for the referral. This clause 12.2 would not apply where we have received the instruction from your Mortgage provider.</p>
          </div>

          <button type="button" className="accordion"><h3>13 Insurance</h3></button>
          <div className="content-box">
            <p>13.1 We shall ensure that, at all times, we hold professional indemnity insurance required by the Royal Institution for Chartered Surveyors (or any subsequent regulatory authority that we are regulated by).</p>
          </div>

          <button type="button" className="accordion"><h3>14 Data and intellectual property ownership and confidentiality</h3></button>
          <div className="content-box">
            <p>14.1 We will own the data and all intellectual property rights in information collected or derived from the property including all site notes and our Report.</p>
            <p>14.2 On payment of the associated fees, we grant to you a licence to use the Report for the purpose set out in the Engagement letter. You are not entitled to copy, reproduce, distribute, amend, or include our Report in any information that you provide to a third party. Our Report is produced for your benefit and no other person can rely upon our Report without our prior written consent, which we can refuse at our discretion.</p>
            <p>14.3 Where we obtain information about you, we will keep that information confidential and only share that information to the extent necessary to provide services to you or to any other client (for example a lender that has instructed us to provide a valuation on the property).</p>
            <p>14.4 We are entitled to use any data that we collect or create in relation to the property for our internal business purposes, for other services that we develop and provide to you or other third parties and in any other way we consider appropriate.</p>
          </div>

          <button type="button" className="accordion"><h3>14 Data and intellectual property ownership and confidentiality</h3></button>
          <div className="content-box">
            <p>14.1 We will own the data and all intellectual property rights in information collected or derived from the property including all site notes and our Report.</p>
            <p>14.2 On payment of the associated fees, we grant to you a licence to use the Report for the purpose set out in the Engagement letter. You are not entitled to copy, reproduce, distribute, amend, or include our Report in any information that you provide to a third party. Our Report is produced for your benefit and no other person can rely upon our Report without our prior written consent, which we can refuse at our discretion.</p>
            <p>14.3 Where we obtain information about you, we will keep that information confidential and only share that information to the extent necessary to provide services to you or to any other client (for example a lender that has instructed us to provide a valuation on the property).</p>
            <p>14.4 We are entitled to use any data that we collect or create in relation to the property for our internal business purposes, for other services that we develop and provide to you or other third parties and in any other way we consider appropriate.</p>
          </div>

          <button type="button" className="accordion"><h3>15 Legal Interest in the Property</h3></button>
          <div className="content-box">
            <p>15.1 We have not been provided with verified details of the legal interest in the Property which you are purchasing. For the purposes of the Report, we will assume that you are purchasing the freehold interest, unless you are buying a flat, in which case we will assume that you are buying the leasehold interest and that the relevant lease has a remaining term of at least 85 years, under which a reasonable ground rent and a service charge proportionate to the value of the Property are payable. We will also assume that the purchase is for owner occupation. If these assumptions are not correct you must inform us prior to us carrying out the inspection. If you do not inform us where these assumptions are not correct, we will not be liable or responsible to you for our services, Report and/or valuation being incorrect as a result. For the avoidance of doubt this clause 15.1 shall not apply to properties located in Scotland.</p>
          </div>

          <button type="button" className="accordion"><h3>16 Reliance on the Report and Third Parties</h3></button>
          <div className="content-box">
            <p>16.1 The Report is to be provided for your personal use only, and e.surv and/or the surveyor responsible for the Report shall not have any liability if the Report is used, or relied upon, by anyone else.</p>
          </div>

          <button type="button" className="accordion"><h3>17 e.surv Safety and Wellbeing Charter</h3></button>
          <div className="content-box">
            <p>17.1 The occupier(s) of the property will be requested to comply with the e.surv Safety and Wellbeing Charter, a copy of which can be found here and on the e.surv website</p>
            <p>17.2 Should the occupier not comply with this and our surveyor is not able to safely undertake a full inspection, e.g., due to social distancing, surface contamination, etc. we reserve the right to withdraw from the inspection. If this were to happen, we will refer back to you prior to finalising our report.</p>
          </div>

          <button type="button" className="accordion"><h3>18 Cladding</h3></button>
          <div className="content-box">
            <p>18.1 If the property comprises a residential flat or apartment, you will be aware that there are well publicised concerns about some of the External Wall Systems fitted to some buildings. UK Government policy and professional guidance is constantly under review and may affect how we report to you. This may result in us being unable to provide a valuation figure on the property. By instructing us you accept that we may require further information, which will need to be obtained and delivered by you, at no cost to us, before a valuation figure can be provided.</p>
            <p>18.2 If we are inspecting a building which includes an External Wall System (cladding) or requires Fire Safety investigation, we may request further specialist investigations are undertaken prior to reporting to you. In such circumstances, our advice will be based upon the information provided to us by external cladding and fire specialists. You will be responsible for instructing the specialist and settling their fees. You acknowledge that we cannot warrant the information so provided.</p>
            <p>18.3 If your instructions refer to a property which comprises a flat/apartment over one storey in height, it may require an EWS 1 (External Wall System) form. We do not have the skill or qualification to interpret or check the accuracy of the EWS 1 form. We have no liability to you, for any losses or potential losses arising directly and solely from reliance by us upon the EWS1 form. If you require further information, then please seek independent advice prior to legal commitment to purchase the property.</p>
          </div>

          <button type="button" className="accordion"><h3>19 Conflict of Interest</h3></button>
          <div className="content-box">
            <p>19.1 We are a member of the LSL Property Services plc group of companies (LSL Group) and details of other group companies can be found at www.lslps.co.uk/who-we-are/our-brands. An LSL Group company may or may not be involved at some point during the property transaction and on occasion we may be acting for the lender and the borrower in the transaction. We are obliged to advise you of this potential for Conflict of Interest however, we are satisfied that we have information barriers and procedures in place to mitigate the risk of any such conflict causing a disadvantage to your position and that proceeding is in the best interests of all those who are or may be affected. Should you choose to complete the confirmation response we will deem that as being your Informed Consent to the potential for conflict.</p>
          </div>

          <button type="button" className="accordion"><h3>20 Third party information</h3></button>
          <div className="content-box">
            <p>20.1 Unless otherwise agreed between us and you, we will not rely on any third-party information for the purposes of preparing the Report.</p>
            <p>20.2 No one other than a party to this contract has any right to enforce any term of this contract.</p>
          </div>

          <button type="button" className="accordion"><h3>21 Right to cancel</h3></button>
          <div className="content-box">
            <p>21.1 You have the right to cancel this contract within 14 days without giving any reason. However, you do not have the right to cancel if you requested for us to start providing the services during the cancellation period and the services are fully performed during this period.</p>
            <p>21.2 The cancellation period will expire after 14 days from the day of the conclusion of the contract.</p>
            <p>21.3 To exercise the right to cancel, you must inform us of your decision to cancel this contract by a clear statement (e.g., a letter sent by post or email) using the contact details on the Engagement Letter.</p>
            <p>21.4 To meet the cancellation deadline, it is sufficient for you to send your communication concerning your exercise of the right to cancel before the cancellation period has expired.</p>
            <p>21.5 We will not start providing the services during the 14-day cancellation period unless you ask us to. You can request for us to start providing the services during the cancellation period by completing the confirmation section referred to in the Engagement Letter. By completing the confirmation section, you acknowledge that you will lose your right to cancel this contract once the services are fully performed (i.e., the work is completed). If you do not complete the confirmation section, we will not be able to start providing the services to you until the cancellation period has expired. We are not obliged to accept your request.</p>
            <p>21.6 This means that if you requested for us to start providing the services during the cancellation period and the services are fully performed (i.e., the work is completed) during this period, you lose your right to cancel and will be required to pay the full price under this contract even if the cancellation period has not expired.</p>
            <p>21.7 This does not affect the rights you have if your services are faulty. A summary of these rights is provided at the top of this contract.</p>
          </div>

          <button type="button" className="accordion"><h3>22 Effects of cancellation</h3></button>
          <div className="content-box">
            <p>22.1 If you cancel this contract, we will reimburse to you all payments received from you unless you requested for us to start providing the services during the cancellation period, in which case you must pay us:</p>
            <p>22.1.1 for the services we provided up to the time you told us that you want to cancel this contract, which will be an amount in proportion to the services performed up to that point in comparison with the full price under this contract; or</p>
            <p>22.1.2 the full price under this contract, if you lost your right to cancel this contract because the services were fully performed (i.e. the work was completed) during the cancellation period.</p>
            <p>22.1.3 We will make the reimbursement without undue delay, and not later than 14 days after the day on which we are informed about your decision to cancel this contract.</p>
            <p>22.1.4 We will make the reimbursement using the same means of payment as you used for the initial transaction, unless you have expressly agreed otherwise; in any event, you will not incur any fees as a result of the reimbursement.</p>
          </div>

          <button type="button" className="accordion"><h3>23 Complaints</h3></button>
          <div className="content-box">
            <p>23.1 If there is any aspect of our service with which you are not happy (including complaints about our bills), please visit our website (www.esurv.co.uk) for details of our complaint's procedure.</p>
          </div>

          <button type="button" className="accordion"><h3>24 Our liability, including Our Limits of liability</h3></button>
          <div className="content-box">
            <p>24.1 We will not have any liability to you in any circumstances unless it has been proven that we are in breach of contract or where it has been proven that we have breached a duty of care owed to you.</p>
            <p>24.2 You should understand that in order to balance risk fairly between us, we have capped some of our legal liabilities.</p>
            <p>24.3 This means that if we were in breach of contract or we breach a duty of care that we owe to you, the maximum aggregate compensation that we will be obliged to pay you would be limited as set out below:</p>
            <p>24.4 We will in no circumstances be liable to you in relation to the valuation of the property unless we have provided to you a formal written opinion of market value. Where we have provided you with a formal written opinion of market value the limitation below will apply.</p>
          </div>

          <button type="button" className="accordion"><h3>25 Valuation limitation</h3></button>
          <div className="content-box">
            <p>(a) Where we are in breach of contract or that we have breached a duty of care relating to our opinion of market value, our aggregate maximum liability to you will be 50% of the lower of: (i) our valuation of the Property, or (ii) the purchase price.</p>
            <p>For example, if we value the property at £200,000, but you then purchase for £190,000, the maximum payment you could recover from us for an incorrect valuation would be £95,000.</p>
            <p style={{ fontWeight: 'bold' }}>Defects and general limitation</p>
            <p>(b) Where we are in breach of contract or we have breached a duty of care in relation to a defect or are liable to you for any other matter connected to the service (other than in relation to our opinion of market value which is covered by (a) above) our aggregate maximum liability to you for all claims will be £50,000.</p>
            <p>25.1 We will also not be liable to you for any loss or damage caused by you. You will also be required to demonstrate any loss that you claim to have suffered and we will not be liable for any loss that you are unable to demonstrate.</p>
            <p>25.2 There is no limit on our liability where you have a claim against us for:</p>
            <p>25.2.1 death or personal injury as a result of negligence; or</p>
            <p>25.2.2 fraud.</p>
            <p>25.3 We shall have no liability to you where any error or omission in the Report is as a result of the inability to inspect the relevant area.</p>
          </div>

          <button type="button" className="accordion"><h3>26 Events beyond our control</h3></button>
          <div className="content-box">
            <p>26.1 We shall not be liable to you if the provision of our services and/or the Report are delayed or cannot be completed as a result of matters outside our reasonable control. For example, where we are prevented by interference by unconnected third parties or government interventions (including but not limited to any local or national lockdown, order or requirement). Where any such event arises, we shall use our reasonable endeavours to provide the service and/or the Report as soon as practicable.</p>
          </div>

          <button type="button" className="accordion"><h3>27 Faculty services</h3></button>
          <div className="content-box">
            <p>27.1 Your legal rights under the Consumer Rights Act 2015 (also known as 'statutory rights') are set out at the top of these terms and conditions. They are a summary of some of your key rights. For more detailed information on your rights and what you should expect from us, please:</p>
            <ul>
              <li>Speak with our representative by calling the number set out in the Engagement Letter</li>
              <li>Visit our website: www.esurv.co.uk; or</li>
              <li>Visit the Citizens Advice website www.citizensadvice.org.uk or call <span className='midnight-blue-text'>03454 04 05 06</span>.</li>
              <li>Nothing in this contract affects your legal rights under the Consumer Rights Act 2015 (also known as ‘statutory rights'). You may also have other rights in law.</li>
              <li>If the services we have provided to you are faulty, please contact us using the contact details in the Engagement Letter.</li>
            </ul>
          </div>

          <button type="button" className="accordion"><h3>28 Your privacy and personal information</h3></button>
          <div className="content-box">
            <p>28.1 Our Privacy Policy is available at https://www.esurv.co.uk/privacy-and-cookies/.</p>
            <p>28.2 Your privacy and personal information are important to us. Any personal information that you provide to us will be dealt with in line with our Privacy Policy, which explains what personal information we collect from you, how and why we collect, store, use and share such information, your rights in relation to your personal information and how to contact us and supervisory authorities if you have a query or complaint about the use of your personal information.</p>
            <p>28.3 In summary, we will use the personal information you provide to us:</p>
            <ul>
              <li>To supply the Report to you</li>
              <li>To process your payment for the Report; and</li>
              <li>If you agree to this during the order process, to give you information about similar products that we provide, but you may stop receiving this at any time by contacting us.</li>
            </ul>
            <p>28.4 We will only pass your personal information to trusted third parties based in the UK, who assist specifically with providing our service to you (e.g. IT platform providers).</p>
          </div>

        </div>

        <hr></hr>

        <div id='customerDetails'>
          <h2>Please complete the fields below to confirm acceptance and understanding of the contract terms</h2>
          <p className="error">* Required field</p>
          <form onSubmit={handleSubmit} style={{ textAlign: 'left', marginTop: 0 }}>

            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="firstName">First Name <span className="error">*</span></label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleFormChange}
                  required
                  className="form-control"
                  placeholder="First Name"

                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="lastName">Last Name <span className="error">*</span></label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleFormChange}
                  required
                  className="form-control"
                  placeholder="Last Name"

                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="email">Email <span className="error">*</span></label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleFormChange}
                  required
                  className="form-control"
                  placeholder="Email Address"

                  autoComplete='on'
                />
              </div>
            </div>

            <h3>Please confirm the address of the property we will be inspecting for you:</h3>
            <p className="error">* Required field</p>

            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="purchasePrice">Purchase price<span className="error">*</span></label>
                <input
                  type="text"
                  id="purchasePrice"
                  name="purchasePrice"
                  value={formData.purchasePrice}
                  onChange={handleFormChange}
                  required
                  className="form-control"
                  placeholder="Purchase Price"

                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="houseNameNumber">House name/number<span className="error">*</span></label>
                <input
                  type="text"
                  id="houseNameNumber"
                  name="houseNameNumber"
                  value={formData.houseNameNumber}
                  onChange={handleFormChange}
                  required
                  className="form-control"
                  placeholder="House name/number"

                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="street">Street<span className="error">*</span></label>
                <input
                  type="text"
                  id="street"
                  name="street"
                  value={formData.street}
                  onChange={handleFormChange}
                  required
                  className="form-control"
                  placeholder="Street"

                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="city">City<span className="error">*</span></label>
                <input
                  type="text"
                  id="city"
                  name="city"
                  value={formData.city}
                  onChange={handleFormChange}
                  required
                  className="form-control"
                  placeholder="City"

                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="county">County<span className="error">*</span></label>
                <input
                  type="text"
                  id="county"
                  name="county"
                  value={formData.county}
                  onChange={handleFormChange}
                  required
                  className="form-control"
                  placeholder="County"

                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="postcode">Postcode<span className="error">*</span></label>
                <input
                  type="text"
                  id="postcode"
                  name="postcode"
                  value={formData.postcode}
                  onChange={handleFormChange}
                  required
                  className="form-control"
                  placeholder="Postcode"
                  pattern="\s*([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\s?[0-9][A-Za-z]{2})\s*"
                  title="Please enter a valid postcode."
                />
              </div>
            </div>


            <table id="check-terms" className="inputGroup">
              <tbody id="checkboxes-container">
                <tr>
                  <td>
                    <input
                      id="check-terms-0"
                      type="checkbox"
                      name="agree0"
                      onChange={handleFormChange}
                      checked={formData.agree0}

                    />
                    <label htmlFor="check-terms-0">
                      I have read, understand and accept the "Description of the RICS Homebuyer [Survey & Valuation] Service" and the contract terms set out above.
                    </label>
                    <span className="error-message" aria-live="polite">Please agree to all terms before submitting.</span>

                  </td>
                </tr>

                <tr>
                  <td>
                    <input
                      id="check-terms-1"
                      type="checkbox"
                      name="agree1"
                      onChange={handleFormChange}
                      checked={formData.agree1}
                    />
                    <label htmlFor="check-terms-1">
                      I confirm that I have also been provided access to the "RICS Home Surveys Information Sheet".
                    </label>
                    <span className="error-message" aria-live="polite">Please agree to all terms before submitting.</span>
                  </td>
                </tr>

                <tr>
                  <td>
                    <input
                      id="check-terms-2"
                      type="checkbox"
                      name="agree2"
                      onChange={handleFormChange}
                      checked={formData.agree2}
                    />
                    <label htmlFor="check-terms-2">
                      I authorise e.surv to immediately commence work on the Report, and I accept that once
                      the Report has been provided to me I will lose my right to cancel during the 14 day "cooling off"
                      period (as provided by the Consumer Contracts (Information, Cancellation and Additional
                      Charges) Regulations 2013).
                    </label>
                    <span className="error-message" aria-live="polite">Please agree to all terms before submitting.</span>
                  </td>
                </tr>

                <tr>
                  <td>
                    <input
                      id="check-terms-3"
                      type="checkbox"
                      name="agree3"
                      onChange={handleFormChange}
                      checked={formData.agree3}
                    />
                    <label htmlFor="check-terms-3">
                      I accept that e.surv may pay or receive a referral fee from a third party in connection with this transaction.
                    </label>
                    <span className="error-message" aria-live="polite">Please agree to all terms before submitting.</span>
                  </td>
                </tr>

                <tr>
                  <td>
                    <input
                      id="check-terms-4"
                      type="checkbox"
                      name="agree4"
                      onChange={handleFormChange}
                      checked={formData.agree4}
                    />
                    <label htmlFor="check-terms-4">
                      I understand that e.surv is a member of the LSL Property Services pls group of companies (LSL Group) and that an LSL Group company may or may not be involved at some point during the property transaction. I confirm my instructions for e.surv to proceed on this basis.
                    </label>
                    <span className="error-message" aria-live="polite">Please agree to all terms before submitting.</span>
                  </td>
                </tr>

                <tr>
                  <td>
                    <input
                      id="check-terms-5"
                      type="checkbox"
                      name="agree5"
                      onChange={handleFormChange}
                      checked={formData.agree5}
                    />
                    <label htmlFor="check-terms-5">

                      I accept that if I exercise my right to cancel after e.surv has commenced work on the
                      Report, but before the Report has been completed, I may be entitled to a partial refund only of
                      the fee paid to e.surv by the mortgage lender on my behalf. The amount of any refund would
                      be based on the part of the fee attributable to the HomeBuyer Report (as distinct from the
                      Mortgage Valuation fee). I understand that no refund would be payable if the cancellation was
                      received after 3pm on the day preceding the appointment to inspect (as provided by the
                      Consumer Contracts (Information, Cancellation and Additional Charges) Regulations 2013).

                    </label>
                    <span className="error-message" aria-live="polite">Please agree to all terms before submitting.</span>
                  </td>
                </tr>

                <tr>
                  <td>
                    <input
                      id="check-terms-6"
                      type="checkbox"
                      name="agree6"
                      onChange={handleFormChange}
                      checked={formData.agree6}
                    />
                    <label htmlFor="check-terms-6">
                      I authorise e.surv to process my personal data in accordance with these terms, and e.surv's privacy policy.
                    </label>
                    <span className="error-message" aria-live="polite">Please agree to all terms before submitting.</span>
                  </td>
                </tr>

              </tbody>
            </table>

            <div className="form-row">
              <div className="form-group col-md-6">
                {submitAttempted && (!formData.agree0 || !formData.agree1 || !formData.agree2 || !formData.agree3 || !formData.agree4 || !formData.agree5 || !formData.agree6) && <p>Please agree to all terms before submitting.</p>}


              </div>
            </div>
            <button type="submit" id="submit-button" disabled={isSubmitting}>Submit</button>
          </form>
        </div>





      </section>
    </main>
  );
}

export default TermsAccept;


